<template>
  <div class="columns-container">
    <div class="column">
      <div v-if="changeOrder.CarConfiguration.OriginalWltpValues">
        <strong>{{ i18n.t('/Emission And Consumption/WLTP Label') }}</strong>
        <div v-if="!changeOrder.CarConfiguration.OriginalWltpValues.HasFailedToFetch">
          <dl class="consumption-block">
            <dt>{{ i18n.t('/Emission And Consumption/Consumption') }}</dt>
            <dd>
              {{ changeOrder.CarConfiguration.OriginalWltpValues.WltpFuelConsumption }}
            </dd>

            <dt>{{ i18n.t('/Emission And Consumption/CO2 Emissions') }}</dt>
            <dd>
              {{ changeOrder.CarConfiguration.OriginalWltpValues.WltpCO2Emission }}
            </dd>

            <template v-if="isElectroCar">
              <dt>{{ i18n.t('/Emission And Consumption/Range') }}</dt>
              <dd>
                {{ changeOrder.CarConfiguration.OriginalWltpValues.WltpRange }}
              </dd>
            </template>
          </dl>
          <div v-if="originalBpmValue">
            <div class="bpm-block">
              <div>
                <strong>
                  {{ i18n.t('/Emission And Consumption/BPM Value Label') }}
                  {{ i18n.n(changeOrder.CarConfiguration.OriginalBpm.Value, 'currency') }}
                </strong>
              </div>
            </div>
            <small>
              {{ i18n.t('/Emission And Consumption/BPM Based WLTP Label') }}
            </small>
          </div>
        </div>
        <div
          v-if="changeOrder.CarConfiguration.OriginalWltpValues.HasFailedToFetch"
          class="incorrect-bpm-warning"
        >
          <strong>
            {{ i18n.t('/Emission And Consumption/Corrupted BPM') }}
          </strong>
        </div>
      </div>
    </div>
    <div class="column">
      <div v-if="changeOrder.CarConfiguration.ChangedWltpValues">
        <strong>{{ i18n.t('/Emission And Consumption/WLTP Label') }}</strong>
        <div v-if="!changeOrder.CarConfiguration.ChangedWltpValues.HasFailedToFetch">
          <dl class="consumption-block">
            <dt>{{ i18n.t('/Emission And Consumption/Consumption') }}</dt>
            <dd>
              {{ changeOrder.CarConfiguration.ChangedWltpValues.WltpFuelConsumption }}
            </dd>

            <dt :class="determineCo2EmissionChangedClass">
              {{ i18n.t('/Emission And Consumption/CO2 Emissions') }}
            </dt>
            <dd :class="determineCo2EmissionChangedClass">
              {{ changeOrder.CarConfiguration.ChangedWltpValues.WltpCO2Emission }}
            </dd>
          </dl>
          <div v-if="changedBpmValue">
            <div class="bpm-block">
              <div>
                <strong>
                  {{ i18n.t('/Emission And Consumption/BPM Value Label') }}
                </strong>
                <strong :class="determineBpmValueChangedClass">
                  {{ i18n.n(changeOrder.CarConfiguration.ChangedBpm.Value, 'currency') }}
                </strong>
              </div>
            </div>
            <small>
              {{ i18n.t('/Emission And Consumption/BPM Based WLTP Label') }}
            </small>
          </div>
        </div>
        <div
          v-if="changeOrder.CarConfiguration.ChangedWltpValues.HasFailedToFetch"
          class="incorrect-bpm-warning"
        >
          <strong>
            {{ i18n.t('/Emission And Consumption/Corrupted BPM') }}
          </strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      unWatch: null,
    }
  },
  computed: {
    ...mapGetters({
      changeOrder: 'changeOrder/get',
    }),
    originalBpmValue() {
      return this.changeOrder.CarConfiguration?.OriginalBpm?.Value
    },
    changedBpmValue() {
      return this.changeOrder.CarConfiguration?.ChangedBpm?.Value
    },
    isElectroCar() {
      //todo bpm code is empty from pcqm
      let configuration = this.changeOrder.CarConfiguration
      return configuration?.BpmCode === 'PE' || configuration?.BpmCode === 'BE'
    },
    determineCo2EmissionChangedClass() {
      if (this.hasCo2EmissionChanged) {
        return 'bpm-changed'
      }
      return ''
    },
    hasCo2EmissionChanged() {
      return (
        this.changeOrder.CarConfiguration.OriginalWltpValues.WltpCO2Emission !==
        this.changeOrder.CarConfiguration.ChangedWltpValues.WltpCO2Emission
      )
    },
    determineBpmValueChangedClass() {
      if (this.hasBpmValueChanged) {
        return 'bpm-changed'
      }
      return ''
    },
    hasBpmValueChanged() {
      return this.originalBpmValue !== this.changedBpmValue
    },
  },
}
</script>
<style lang="scss" scoped>
.columns-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.column {
  flex: 1;
  margin: 0 10px;
  padding: 0.5rem;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.consumption-block {
  @extend .grid-container;
  margin: 10px;

  dt {
    grid-column: 1;
  }

  dd {
    grid-column: 2;
  }
}

.bpm-block {
  @extend .grid-container;
  margin: 30px 0;
}

.incorrect-bpm-warning {
  background-color: $color-warning;
  color: $white;
  padding: 5px;
  box-shadow: $shadow-sm;
  border-radius: 1px;
}

.bpm-changed {
  background-color: #fff8b9;
}
</style>
